export default __webpack_public_path__ + "static/media/icon-person-biometry-male-error.7efd3ebd.svg";